export default __webpack_public_path__ + "static/media/gallery_05.fd4ab4f9.jpg";